import React, { useContext } from 'react';
import {
    faRedoAlt,
    faTimes,
    faCheckSquare,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../../../../../context';
import classNames from 'classnames';
import { DaylightContext } from '../../../../../DaylightCodeMapper';
import './styles.css';

const MarkCodeComplete = ({ code, isUpdating }) => {
    const dispatch = useDispatch();
    let buttonIcon = faRedoAlt;
    if (!isUpdating)
        buttonIcon = code?.confirmationStatus ? faTimes : faCheckSquare;

    // TODO: make sure this is working correctly
    const { practiceId, partnerId } = useContext(DaylightContext);

    // TODO: force some breaking behavior so we can ensure our error handling is on point
    const handleMarkingComplete = () => {
        if (code?.confirmationStatus) {
            dispatch(
                actions.daylight.unmarkCodeComplete(practiceId, code, partnerId)
            );
        } else {
            if (code?.needsReview) {
                dispatch(
                    actions.daylight.unmarkCodeForReview(
                        practiceId,
                        code,
                        partnerId
                    )
                );
            }

            dispatch(
                actions.daylight.markCodeComplete(practiceId, code, partnerId)
            );
        }
    };

    return (
        <FontAwesomeIcon
            className={classNames('ml-2 confirm-mapping pop-hoverable', {
                rotating: isUpdating,
                'fa-disabled': isUpdating,
            })}
            icon={buttonIcon}
            onClick={handleMarkingComplete}
            title={
                code?.confirmationStatus
                    ? 'Mark Code Not Complete'
                    : 'Mark Code Complete'
            }
            size="lg"
        />
    );
};

export default MarkCodeComplete;
